import { ref } from 'vue';
import { snippetsClient } from '~/services';
import { createGlobalState } from '@vueuse/core';
import { chunkArray } from '~/utils/array';

const IDS_PER_REQUEST = 10;

export const useSnippetsGroupsCount = createGlobalState(() => {
    const teamId = Spark.state.currentTeam.id;

    // [snippetId]: groupsCount
    // undefined = loading
    // null = not found
    const groupCounts = ref({});

    const fetching = ref(false);

    /**
     * @param {number[]} snippetIds
     */
    const fetchSnippetsGroupsCount = async (snippetIds) => {
        // remove existing ids to avoid computing them again
        snippetIds = snippetIds.filter((snippetId) => !groupCounts.value[snippetId]);

        if (!snippetIds.length) {
            return;
        }

        if (fetching.value) {
            // when its currently making a request call wait a bit before retrieving again
            setTimeout(() => {
                fetchSnippetsGroupsCount(snippetIds);
            }, 500);
            return;
        }

        try {
            fetching.value = true;

            for (const batch of chunkArray(snippetIds, IDS_PER_REQUEST)) {
                const response = await snippetsClient.getSnippetsGroupCounts(
                    { teamId },
                    {
                        snippet_ids: batch,
                    }
                );

                batch.forEach((snippetId) => {
                    groupCounts.value[snippetId] = response.data.counts[snippetId] ?? 0;
                });
            }
        } finally {
            fetching.value = false;
        }
    };

    return {
        fetchSnippetsGroupsCount,
        groupCounts,
    };
});
